/**
 * @generated SignedSource<<2d6d57794bebfbcb374c30e75482869b>>
 * @relayHash 01f353144b31de8ad0f5c750ad4803ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c0a781ddec41cf88f1eb43e2c0a9160dca7d8e986dc68d881b6c3a855c42bf6d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewQuery } from './SupportWebsiteOverviewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c0a781ddec41cf88f1eb43e2c0a9160dca7d8e986dc68d881b6c3a855c42bf6d",
    "metadata": {},
    "name": "SupportWebsiteOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
